import { Link } from "react-router-dom";

const articles = [
  {
    title: "USFans Spreadsheet: Kompletny przewodnik 2026",
    desc: "Wszystko, co musisz wiedzieć o USFans Spreadsheet — od podstaw po zaawansowane strategie dla agencji. Dowiedz się, jak wykorzystać creator database do maksymalizacji wyników.",
    link: "/artykul/usfans-spreadsheet-kompletny-przewodnik-2026",
    tag: "Poradnik",
    image: "https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20laptop%20displaying%20data%20analytics%20dashboard%20and%20spreadsheet%20charts%2C%20clean%20minimalist%20desk%20setup%20with%20warm%20lighting%2C%20professional%20creative%20atmosphere%2C%20editorial%20photography%20style%2C%20soft%20natural%20light%20from%20window%2C%20warm%20coral%20accent%20details%2C%20cozy%20productive%20vibe&width=600&height=400&seq=art-thumb-01&orientation=landscape"
  },
  {
    title: "Jak znaleźć twórców szybciej? Praktyczny poradnik",
    desc: "Poznaj strategie szybkiego scoutingu twórców i dowiedz się, jak USFans Spreadsheet usprawnia proces wyszukiwania idealnych partnerów do kampanii.",
    link: "/artykul/usfans-spreadsheet-kompletny-przewodnik-2026",
    tag: "Strategia",
    image: "https://readdy.ai/api/search-image?query=Creative%20professional%20analyzing%20creator%20profiles%20on%20tablet%20device%20with%20colorful%20social%20media%20charts%2C%20modern%20office%20background%2C%20warm%20ambient%20lighting%2C%20editorial%20photography%2C%20clean%20composition%2C%20soft%20sage%20green%20and%20beige%20tones%2C%20focused%20work%20atmosphere&width=600&height=400&seq=art-thumb-02&orientation=landscape"
  },
  {
    title: "USFans Spreadsheet vs ręczny research — porównanie 2026",
    desc: "Porównujemy efektywność USFans Spreadsheet z tradycyjnym researchowaniem twórców. Sprawdź, która metoda daje lepsze rezultaty.",
    link: "/artykul/usfans-spreadsheet-kompletny-przewodnik-2026",
    tag: "Porównanie",
    image: "https://readdy.ai/api/search-image?query=Side%20by%20side%20comparison%20concept%20with%20digital%20spreadsheet%20and%20handwritten%20notes%20on%20wooden%20desk%2C%20minimalist%20workspace%2C%20warm%20natural%20lighting%2C%20editorial%20style%2C%20clean%20modern%20aesthetic%2C%20professional%20atmosphere%2C%20soft%20neutral%20color%20palette&width=600&height=400&seq=art-thumb-03&orientation=landscape"
  },
  {
    title: "Top 10 najlepszych narzędzi dla agencji w 2026",
    desc: "Kompleksowy ranking narzędzi analitycznych, które pomogą Twojej agencji wyprzedzić konkurencję. USFans Spreadsheet na pierwszym miejscu.",
    link: "/artykul/usfans-spreadsheet-kompletny-przewodnik-2026",
    tag: "Ranking",
    image: "https://readdy.ai/api/search-image?query=Professional%20digital%20marketing%20tools%20displayed%20on%20clean%20white%20desk%2C%20modern%20creative%20workspace%20with%20analytics%20screens%2C%20warm%20ambient%20office%20lighting%2C%20editorial%20photography%2C%20minimalist%20composition%2C%20sage%20green%20and%20coral%20accent%20colors%2C%20productive%20atmosphere&width=600&height=400&seq=art-thumb-04&orientation=landscape"
  },
  {
    title: "Creator database: Jak zbudować skuteczną bazę twórców?",
    desc: "Przewodnik krok po kroku po budowaniu własnej bazy twórców. Poznaj kluczowe metryki i dowiedz się jak efektywnie zarządzać danymi.",
    link: "/artykul/usfans-spreadsheet-kompletny-przewodnik-2026",
    tag: "Poradnik",
    image: "https://readdy.ai/api/search-image?query=Organized%20database%20concept%20with%20digital%20tablet%20showing%20creator%20profile%20grid%2C%20clean%20workspace%20with%20coffee%20and%20notebook%2C%20warm%20morning%20light%2C%20editorial%20photography%20style%2C%20minimalist%20aesthetic%2C%20soft%20neutral%20tones%2C%20professional%20creative%20environment&width=600&height=400&seq=art-thumb-05&orientation=landscape"
  },
  {
    title: "OnlyFans analytics: Kompletny przewodnik po analityce twórców",
    desc: "Zrozum kluczowe wskaźniki analityczne i dowiedz się, jak wykorzystać dane do maksymalizacji zysków z kampanii z twórcami.",
    link: "/artykul/usfans-spreadsheet-kompletny-przewodnik-2026",
    tag: "Analityka",
    image: "https://readdy.ai/api/search-image?query=Analytics%20dashboard%20with%20colorful%20charts%20and%20graphs%20on%20computer%20screen%2C%20modern%20minimalist%20desk%20setup%2C%20warm%20ambient%20lighting%2C%20editorial%20photography%2C%20clean%20professional%20aesthetic%2C%20soft%20coral%20and%20beige%20color%20scheme%2C%20focused%20work%20atmosphere&width=600&height=400&seq=art-thumb-06&orientation=landscape"
  },
  {
    title: "Baza twórców OnlyFans — od czego zacząć w 2026?",
    desc: "Praktyczny poradnik dla początkujących agencji. Jak zbudować pierwszą bazę twórców i uniknąć najczęstszych błędów.",
    link: "/artykul/usfans-spreadsheet-kompletny-przewodnik-2026",
    tag: "Poradnik",
    image: "https://readdy.ai/api/search-image?query=Beginner%20friendly%20workspace%20with%20open%20laptop%20showing%20spreadsheet%20tutorial%2C%20notebook%20and%20pen%2C%20warm%20natural%20daylight%2C%20editorial%20photography%2C%20clean%20minimalist%20composition%2C%20soft%20neutral%20palette%2C%20encouraging%20learning%20atmosphere&width=600&height=400&seq=art-thumb-07&orientation=landscape"
  },
  {
    title: "Jak zarabiać na creator economy? Strategie dla agencji",
    desc: "Sprawdzone metody monetyzacji w gospodarce twórców. Dowiedz się, jak skalować biznes agencyjny z USFans Spreadsheet.",
    link: "/artykul/usfans-spreadsheet-kompletny-przewodnik-2026",
    tag: "Strategia",
    image: "https://readdy.ai/api/search-image?query=Business%20growth%20concept%20with%20financial%20charts%20and%20rising%20graph%20on%20screen%2C%20modern%20office%20with%20plants%2C%20warm%20golden%20hour%20lighting%2C%20editorial%20photography%2C%20clean%20professional%20aesthetic%2C%20soft%20amber%20and%20cream%20tones%2C%20optimistic%20atmosphere&width=600&height=400&seq=art-thumb-08&orientation=landscape"
  },
  {
    title: "USFans Spreadsheet — recenzja i pierwsze wrażenia",
    desc: "Szczegółowa recenzja narzędzia USFans Spreadsheet. Testujemy wszystkie funkcje i dzielimy się szczerą opinią po miesiącu użytkowania.",
    link: "/artykul/usfans-spreadsheet-kompletny-przewodnik-2026",
    tag: "Recenzja",
    image: "https://readdy.ai/api/search-image?query=Product%20review%20setup%20with%20laptop%20displaying%20spreadsheet%20interface%20on%20wooden%20desk%2C%20coffee%20cup%20nearby%2C%20warm%20cozy%20lighting%2C%20editorial%20photography%2C%20clean%20minimalist%20aesthetic%2C%20soft%20natural%20tones%2C%20honest%20review%20vibe&width=600&height=400&seq=art-thumb-09&orientation=landscape"
  },
  {
    title: "Automatyzacja researchu twórców — poradnik 2026",
    desc: "Jak zautomatyzować proces wyszukiwania i analizy twórców. Oszczędź 20 godzin tygodniowo dzięki inteligentnym narzędziom.",
    link: "/artykul/usfans-spreadsheet-kompletny-przewodnik-2026",
    tag: "Automatyzacja",
    image: "https://readdy.ai/api/search-image?query=Automation%20concept%20with%20multiple%20screens%20showing%20data%20processing%2C%20modern%20tech%20workspace%2C%20warm%20ambient%20lighting%2C%20editorial%20photography%2C%20clean%20futuristic%20aesthetic%2C%20soft%20coral%20and%20sage%20accents%2C%20efficient%20workflow%20atmosphere&width=600&height=400&seq=art-thumb-10&orientation=landscape"
  },
  {
    title: "Trendy w creator economy na 2026 rok",
    desc: "Najnowsze trendy i prognozy dla gospodarki twórców. Bądź o krok przed konkurencją dzięki aktualnym danym z USFans Spreadsheet.",
    link: "/artykul/usfans-spreadsheet-kompletny-przewodnik-2026",
    tag: "Trendy",
    image: "https://readdy.ai/api/search-image?query=Future%20trends%20concept%20with%20digital%20dashboard%20showing%20upward%20trends%20and%20data%20visualizations%2C%20modern%20creative%20workspace%2C%20warm%20natural%20lighting%2C%20editorial%20photography%2C%20clean%20minimalist%20composition%2C%20soft%20amber%20and%20beige%20tones%2C%20forward%20looking%20atmosphere&width=600&height=400&seq=art-thumb-11&orientation=landscape"
  },
  {
    title: "Najczęstsze błędy przy wyborze twórców — jak ich uniknąć?",
    desc: "Analiza najczęstszych pułapek przy selekcji twórców do kampanii. Praktyczne wskazówki poparte danymi z creator database.",
    link: "/artykul/usfans-spreadsheet-kompletny-przewodnik-2026",
    tag: "Poradnik",
    image: "https://readdy.ai/api/search-image?query=Problem%20solving%20concept%20with%20magnifying%20glass%20over%20data%20charts%20on%20desk%2C%20modern%20office%20setup%2C%20warm%20ambient%20lighting%2C%20editorial%20photography%2C%20clean%20professional%20aesthetic%2C%20soft%20neutral%20palette%2C%20analytical%20thinking%20atmosphere&width=600&height=400&seq=art-thumb-12&orientation=landscape"
  },
];

export default function ArticlesSection() {
  return (
    <section className="relative w-full bg-background-100 py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            Popularne artykuły i poradniki
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Poznaj USFans Spreadsheet od podstaw i wykorzystaj jego pełny potencjał.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {articles.map((article) => (
            <Link
              key={article.title}
              to={article.link}
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 overflow-hidden transition-all duration-200"
            >
              {/* Article thumbnail */}
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs font-medium text-background-50 bg-primary-500/90 px-2.5 py-1 rounded-full whitespace-nowrap">
                    {article.tag}
                  </span>
                </div>
              </div>
              {/* Article content */}
              <div className="p-4 flex flex-col flex-1">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed mb-3 flex-1 line-clamp-2">
                  {article.desc}
                </p>
                <span className="inline-flex items-center text-xs font-medium text-primary-500 group-hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
                  Czytaj więcej
                  <i className="ri-arrow-right-line ml-1"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}